import Attribute from "../../../Firestore/Attribute";

export const buildExerciseNameWithModifiers = (exerciseName, modifiers, language) => {
  if (!modifiers || modifiers.length === 0) {
    return exerciseName;
  }

  let selectedEquipment = "";
  let selectedTempo = "";
  let selectedROM = "";
  let selectedStanceGrip = "";
  let selectedLoadAccomodation = "";
  let selectedAccessories = "";
  let selectedOther = "";

  if (language === "es") {
    modifiers.forEach((modifier) => {
      const modifierName = modifier.name;
      switch (modifier.type) {
        case Attribute.AttributeTitles.equipment:
          selectedEquipment = ` con ${modifierName}`;
          break;
        case Attribute.AttributeTitles.rom:
          selectedROM = ` ${modifierName}`;
          break;
        case Attribute.AttributeTitles.tempo:
          selectedTempo = ` ${modifierName}`;
          break;
        case Attribute.AttributeTitles.stanceGrip:
          selectedStanceGrip = ` ${modifierName}`;
          break;
        case Attribute.AttributeTitles.loadAccomodation:
          selectedLoadAccomodation += ` ${modifierName}`;
          break;
        case Attribute.AttributeTitles.accessories:
          selectedAccessories += ` ${modifierName}`;
          break;
        default:
          selectedOther += ` ${modifierName}`;
      }
    });

    return `${exerciseName}${selectedTempo}${selectedROM}${selectedStanceGrip}${selectedLoadAccomodation}${selectedAccessories}${selectedOther}${selectedEquipment}`;
  }

  modifiers.forEach((modifier) => {
    const modifierName = modifier.name;
    switch (modifier.type) {
      case Attribute.AttributeTitles.equipment:
        selectedEquipment = `${modifierName} `;
        break;
      case Attribute.AttributeTitles.rom:
        selectedROM = `${modifierName} `;
        break;
      case Attribute.AttributeTitles.tempo:
        selectedTempo = `${modifierName} `;
        break;
      case Attribute.AttributeTitles.stanceGrip:
        selectedStanceGrip = `${modifierName} `;
        break;
      case Attribute.AttributeTitles.loadAccomodation:
        selectedLoadAccomodation += `${modifierName} `;
        break;
      case Attribute.AttributeTitles.accessories:
        selectedAccessories += `${modifierName} `;
        break;
      default:
        selectedOther += `${modifierName} `;
    }
  });

  return `${selectedEquipment}${selectedTempo}${selectedROM}${selectedStanceGrip}${selectedLoadAccomodation}${selectedAccessories}${selectedOther}${exerciseName}`;
};
